import React, { Component } from "react";
import { Card, CardBody, Progress, FormText } from 'reactstrap';
import NotificationSystem from "react-notification-system";
import { apiActions, alertActions, commonActions, modalActions } from "../../_actions";
import { appConstants, alertConstants } from "../../_constants";
import { appHelpers, store } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { connect } from "react-redux";
import { commonService } from "../../_services";
import ViewHeader from "./view-header";
import SearchPanel from "./dispute-panel";
import PaginatedResult from './record';
import moment from 'moment';
import DisputeModal from './pop-modal';
import ReportIcon from "react-icons/lib/md/landscape";





// function setCategories() {
//     return (activeUser.AirlineCode === null) ? [
//         { label: 'Airline', value: 'AirlineId' },
//         { label: 'Departure', value: 'DepartureAirportId' },
//         { label: 'Destination', value: 'DestinationairportId' },
//         { label: 'Flight Number', value: 'FlightNumber' },
//         { label: 'Status', value: 'Status' },

//     ] :
//         [
//             { label: 'Departure', value: 'DepartureAirportId' },
//             { label: 'Destination', value: 'DestinationairportId' },
//             { label: 'Flight Number', value: 'FlightNumber' },
//             { label: 'Status', value: 'Status' },
//         ];
// }

let activeUser = appHelpers.getActiveUser();
const Status = [
    { label: 'Save', value: 0, cat: 'statusType' },
    { label: 'Pending', value: 1, cat: 'statusType' },
    { label: 'Initiate', value: 2, cat: 'statusType' },
    { label: 'Approved', value: 3, cat: 'statusType' },
    { label: 'Rejected', value: 4, cat: 'statusType' },

]

const ViewContent = ({ children }) => (
    <div className="view-content view-components">{children}</div>
);

class DisputeEntry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpenApprove: false,
            isOpenInitiate: false,
            isOpenReject: false,
            isOpenSave: false,
            flightDate: new Date(),
            departureDate: new Date(),
            airlines: [],
            activeUser: activeUser,
            desAirports: [],
            depAirports: [],
            searchFlightNumbers: [],
            status: Status,
            tickets: [],
            records: [],
            dialogTitle: "",
            initiateId: null,
            approveId: null,
            rejectId: null,
            saveId: null,
            comments: "",
            dataFiles: "",
            disputevalues: "",
            selectedFile: "",
            file: null,
            commentValue: null,
            valueDispute: null,
            ticketValue: null,
            depValue: null,
            airlineValue: null,
            desValue: null,
            flightValue: null,
            statusValue: null,
            //page error
            contentError: false,  //Errors that affect content on the page
            componentError: false,  //Errors generated within the component
            componentErrorMessages: [], //Errors generated within the component form
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
                // title: 'Default Title',
                message: 'Default Message',
                level: 'success',
                position: 'tr',
                dismissible: true,
            },
            //modal
            modal: false,
            approveModal: false,
            rejectModal: false,
            modalClass: "",
            //
            pageSize: 10,
            currentPage: 1,
            totalCount: 0,
            manifestInfo: false,
            clickBD: false,
            manifestLink: '#',
            airlineSelectNotification: null
        };
        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }


    componentWillReceiveProps = function (nextProps) {
        const { alert } = nextProps;
        if (alert) {
            if (alert.type === alertConstants.SUCCESS) {
                this.setState({ error: false, success: "Operation successful" });
                this.resetForm();
            } else if (alert.type === alertConstants.CLEAR) {
                this.setState({ success: false, error: false });
            } else {
                this.setState({ success: false, error: alert.message });
            }
        }
    };

    componentDidUpdate(prevProps, prevState) {
        const { clickBD } = this.state;
        if (clickBD) {
            this.searchDisputeEntry(1);
            this.setState({ clickBD: false });
        }
    }

    resetError() {
        this.props.dispatch(modalActions.clear());
        this.props.dispatch(alertActions.clear());
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        //    Fetch Airlines
        const reduxState = store.getState();
        const { user } = this.props;
        // debugger;
        if (reduxState.airlinesCarriers) {
            this.setState({ airlines: this.formatAirlines(reduxState.airlinesCarriers.Results) }, () => {
                if (user && this.state.airlines) {
                    // debugger;
                    const fetch = this.state.airlines.filter((item, index) => {
                        return item.Id === user.AirlineId
                    })
                    if (Array.isArray(fetch)) {
                        this.setState({ airlineValue: fetch[0] }, () => {
                            if (this.state.airlineValue) {
                                this.fetchAirlineFlightNumbers(this.state.airlineValue.Id);
                            }
                        })
                    }
                }
            });
        } else {
            this.fetchAirlines();
        }
        // Fetch Destination Airports
        if (reduxState.desAirports) {
            this.setState({
                desAirports: this.formatDestinationAirports(reduxState.desAirports.Results)
            });
        } else {
            this.fetchDesAirports();
        }
        // Fetch Departure Airports
        if (reduxState.depAirports) {
            this.setState({
                depAirports: this.formatDepartureAirports(reduxState.depAirports.Results)
            });
        } else {
            this.fetchDepAirports();
        }
        // if (user.userRole === appConstants.ROLES.AIRLINE_ADMIN || user.userRole ===  appConstants.ROLES.AIRLINE_STAFF ) {
        //     let userObj = {...user};
        //     let userAirline = {value: userObj.AirlineId, label: userObj.AirlineName};
        //     this.setState({ AirlineId: userAirline });
        // let payload = {
        //     StartDate: moment(startDate).format('YYYY-MM-DD') + "T00:00:00",
        //     EndDate: moment(endDate).format('YYYY-MM-DD') + "T23:59:59",
        //     AirlineId: user.AirlineId,
        //     from: 1,
        //     size: pageSize,
        // };
    }

    notify = (message, level) => {
        let notification = this.state.notification;
        notification["message"] = message;
        notification["level"] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(
            notification
        );
    };


    // API CALLS
    searchDisputeEntry = (pageNumber = 1) => {
        if (this.validateInput()) {
        const { dispatch } = this.props;
        const { pageSize, flightDate, ticketValue, desValue, depValue,
            statusValue, airlineValue, flightValue
        } = this.state;
        if (ticketValue  === null ) {
            dispatch(apiActions.startRequest());
            const payload = {
                From: pageNumber,
                Size: pageSize,
                FlightDate: moment(flightDate).format("YYYY-MM-DD"),
                // TicketNumber: ticketValue ? ticketValue.value : "",
                AirlineId: airlineValue.Id,
                DepartureAirportId: depValue.value,
                DestinationairportId: desValue.value,
                FlightNumber: flightValue.value,
                ProcessStatus: statusValue ? statusValue.value : "",
            }


            commonService.searchDispute(payload)
                .then((res) => {
                    let response = res.response;
                    // this.notify("Resources Found",appConstants.NOTIFY_SUCCESS);
                    this.setState({
                        currentPage: pageNumber === 0 ? 1 : pageNumber,
                        records: response.data.DisputeEventModels,
                        totalCount: response.data.TotalCount
                    });
                    dispatch(apiActions.endRequest());
                })
                .catch((error) => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    //dispatch(alertActions.error(errorMessage));
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                    this.setState({ contentError: errorMessage })
                });

        } else {
            dispatch(apiActions.startRequest());
            const payload = {
                From: pageNumber,
                Size: pageSize,
                FlightDate: moment(flightDate).format("YYYY-MM-DD"),
                TicketNumber: ticketValue ? ticketValue.value : "",
                AirlineId: airlineValue.Id,
                DepartureAirportId: depValue.value,
                DestinationairportId: desValue.value,
                FlightNumber: flightValue.value,
                ProcessStatus: statusValue ? statusValue.value : "",
            }


            commonService.searchDispute(payload)
                .then((res) => {
                    let response = res.response;
                    // this.notify("Resources Found",appConstants.NOTIFY_SUCCESS);
                    this.setState({
                        currentPage: pageNumber === 0 ? 1 : pageNumber,
                        records: response.data.DisputeEventModels,
                        totalCount: response.data.TotalCount
                    });
                    dispatch(apiActions.endRequest());
                })
                .catch((error) => {
                    let errorMessage = appHelpers.interpretErrorResponse(error);
                    //dispatch(alertActions.error(errorMessage));
                    this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                    dispatch(apiActions.endRequest());
                    this.setState({ contentError: errorMessage })
                });


        }
    }
    };



    fetchAirlines = () => {
        const { dispatch, user } = this.props;
        this.setState({ contentError: false });
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                const { airlinesCarriers } = this.props;
                this.setState({ airlines: this.formatAirlines(airlinesCarriers.Results) }, () => {
                    if (user && this.state.airlines) {
                        // debugger;
                        const fetch = this.state.airlines.filter((item, index) => {
                            return item.Id === user.AirlineId
                        })
                        if (Array.isArray(fetch)) {
                            this.setState({ airlineValue: fetch[0] }, () => {
                                if (this.state.airlineValue) {
                                    this.fetchAirlineFlightNumbers(this.state.airlineValue.Id);
                                }
                            })
                        }
                    }
                }
                );
                //this.formatAirlines(res.data.Results);
                dispatch(apiActions.endRequest());
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
                dispatch(apiActions.endRequest());
            });
    }

    fetchAirlineFlightNumbers = (airlineId) => {
        const { dispatch } = this.props;
        dispatch(apiActions.startRequest());
        this.setState({ searchFlightNumbers: [] });
        commonService.getAirlinesFlightNumbers(airlineId)
            .then((res) => {
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ searchFlightNumbers: this.formatFlightNumbers(response.Results) });
                    dispatch(apiActions.endRequest());
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(apiActions.endRequest());
                }
            });
    };

    fetchAirlineTicketNumbers = (flightValue, depValue, desValue, airlineValue, flightDate) => {
        const { dispatch } = this.props;
        // const {flightValue, depValue, desValue, airlineValue, flightDate} =this.state;
        dispatch(apiActions.startRequest());
        let payload = {
            airlineid: airlineValue,
            DestinationairportId: desValue,
            DepartureAirportId: depValue,
            flightnumber: flightValue,
            FlightDate: moment(flightDate).format("YYYY-MM-DD") + "T00:00:00",
        }

        this.setState({ tickets: [] });
        commonService.getTicketNumbers(payload)
            .then((res) => {
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    if (response.data.length > 0) {
                        if (response.data[0].Results.length > 0) {
                            this.setState({ tickets: this.formatData(response.data[0].Results) });
                            dispatch(apiActions.endRequest());
                        }
                    } else {
                        this.setState({
                            tickets: [
                                { label: "No Ticket Number", value: -1 }
                            ]
                        });
                        dispatch(apiActions.endRequest());
                    }

                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(apiActions.endRequest());
                }
            });
    };


    fetchDesAirports = () => {
        const { dispatch } = this.props;
        this.setState({ contentError: false });
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getDesAirports())
            .then(() => {
                const airports = this.props.desAirports;
                let desAirports = airports.Results;
                desAirports = this.formatDestinationAirports(desAirports);
                this.setState({
                    desAirports
                });
                dispatch(apiActions.endRequest());
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
                dispatch(apiActions.endRequest());
            });
    }

    fetchDepAirports = () => {
        const { dispatch } = this.props;
        this.setState({ contentError: false });
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getDepAirports())
            .then(() => {
                const airports = this.props.depAirports;
                //
                let depAirports = airports.Results;
                depAirports = this.formatDepartureAirports(depAirports);
                this.setState({
                    depAirports
                });
                dispatch(apiActions.endRequest());
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
                dispatch(apiActions.endRequest());
            });
    }

    initiate = () => {
        const { user, dispatch } = this.props;
        const { initiateId } = this.state

        const payload = {
            UserId: user.userId,
            DisputeId: initiateId,
            Username: user.userName
        }

        dispatch(apiActions.startRequest());
        commonService.InitiateDisputeLog(payload)
            .then(res => {
                dispatch(apiActions.endRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let msg = "Dispute initiated succesfully"
                    this.notify(msg, appConstants.NOTIFY_SUCCESS)
                    this.setState({ isOpenInitiate: false })
                    this.searchDisputeEntry();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                    this.setState({error: res.response})
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            });

    };

    approve = () => {
        const { user, dispatch } = this.props;
        const { approveId } = this.state

        const payload = {
            UserId: user.userId,
            DisputeId: approveId,
            Username: user.userName
        }

        dispatch(apiActions.startRequest());
        commonService.approveDisputeLog(payload)
            .then(res => {

                dispatch(apiActions.endRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let msg = "Dispute approved succesfully"
                    this.notify(msg, appConstants.NOTIFY_SUCCESS)
                    this.setState({ isOpenApprove: false })
                    this.searchDisputeEntry();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                    this.setState({error: res.response})
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            });

    };

    reject = () => {
        const { user, dispatch } = this.props;
        const { rejectId } = this.state

        const payload = {
            UserId: user.userId,
            DisputeId: rejectId,
            Username: user.userName
        }

        dispatch(apiActions.startRequest());
        commonService.rejectDisputeLog(payload)
            .then(res => {
                dispatch(apiActions.endRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let msg = "Dispute rejected succesfully"
                    this.notify(msg, appConstants.NOTIFY_SUCCESS)
                    this.setState({ isOpenReject: false })
                    this.searchDisputeEntry();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                    this.setState({error: res.response})
                }
            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            });

    };

    save = (event) => {
        event.preventDefault();
        const { dispatch } = this.props;
        this.setState({ contentError: false });
        dispatch(apiActions.startRequest());
        const { file,commentValue, valueDispute,saveId} = this.state;

        let data = new FormData();
        data.append("Filepath", file ? file : undefined);
        data.append("comment", commentValue);
        data.append("passengerId", saveId);
        data.append("disputeValue", valueDispute);
        data.append("CreatedBy", this.props.user.userId);
        data.append("Username", this.props.user.userName);

        commonService.saveDisputeLog(data)
            .then(res => {
                dispatch(apiActions.endRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let msg = "Dispute value saved succesfully"
                    this.notify(msg, appConstants.NOTIFY_SUCCESS)
                    this.setState({ isOpenSave: false })
                    this.searchDisputeEntry();
                }

                else if (res.status === appConstants.ERROR_RESPONSE) {
                    this.notify(res.response, appConstants.NOTIFY_ERROR);
                     this.setState({error: res.response})
                    // this.setState({ isOpenSave: false })
                }

            })
            .catch(err => {
                dispatch(alertActions.error(err.response))
            });

    };


    //modals toggle

    approveToggle = (e, record, modalClass) => {
        if (this.state.isOpenApprove) {
            this.setState({ isOpenApprove: false })
            this.resetError();
            return
        } else {
            this.setState({ isOpenApprove: true, approveId: record.Id })
            this.resetError();
        }
    };

    saveToggle = (e, record, modalClass) => {
        if (this.state.isOpenSave) {
            this.setState({ isOpenSave: false })
            this.resetForm();
            return
        } else {
            this.setState({ isOpenSave: true, saveId: record.PassengerId })
            this.resetForm();
        }
    };

    initiateToggle = (e, record, modalClass) => {
        if (this.state.isOpenInitiate) {
            this.setState({ isOpenInitiate: false })
            this.resetError();
            return
        } else {
            this.setState({ isOpenInitiate: true, initiateId: record.Id })
            this.resetError();
        }
    };

    rejectToggle = (e, record, modalClass) => {
        if (this.state.isOpenReject) {
            this.setState({ isOpenReject: false })
            this.resetError();
            return
        } else {
            this.setState({ isOpenReject: true, rejectId: record.Id })
            this.resetError();
        }
    };



    //update selected values
    handleSelectChange = (value, attribute, airlineValue) => {
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        this.setState({ [attribute]: value }, () => {
            const { flightValue, depValue, desValue, airlineValue, flightDate } = this.state;

            if (this.state.statusValue === null)
                if (flightDate && flightValue && desValue && depValue) {
                    this.fetchAirlineTicketNumbers(flightValue.value, depValue.value, desValue.value, airlineValue.Id, flightDate);
                }
        });
        if (airlineValue === true) {
            this.setState({ airlineValue: value })
            this.fetchAirlineFlightNumbers(value.Id);
        }
    };

    //HANDLERS
    formatDestinationAirports = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'DestinationairportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    formatDepartureAirports = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'DepartureAirportId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    formatFlightNumbers = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'FlightNumber';
            item['label'] = item.FlightNumber;
            item['value'] = item.FlightNumber;
            data.push(item);
        }

        return data;
    };

    formatData(data) {
        const res = data.map(item => ({
            value: item.ActualTicket,
            label: item.ActualTicket
        }));

        return res;
    }

    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Id;
            data.push(item);
        }

        return data;
    };

    resetForm() {
        this.setState({
          componentError: false,
          componentErrorMessages: [],
          selectedFile: "",
          file: "",
          commentValue: "",
          valueDispute: "",
          approveId: "",
          initiateId: "",
          rejectId: "",
        });
        this.resetError();
      }
    

      changeDatePicker = (date, target) => {
        this.setState({ [target]: date });
      };

    handleFileChange = (event) => {
        this.setState({file: event.target.files[0]});
    };

    handleInputChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };


    interpretAirport = (airportId) => {
        const { depAirports } = this.state;
        let check = depAirports.find(item => item.Id === airportId);
        if (check) {
            return check.Name;
        } else {
            return `Unknown Airport #${airportId}`;
        }
    };

    interpretDesAirport = (airportId) => {
        const { desAirports } = this.state;
        let check = desAirports.find(item => item.Id === airportId);
        if (check) {
            return check.Name;
        } else {
            return `Unknown Airport #${airportId}`;
        }
    };
    renderPageResponse =()=> {
        if (this.state.error) {
          return <div className="alert alert-danger">{this.state.error}</div>;
        } else if (this.state.componentError) {
          return (
            <div className="alert alert-danger">{this.state.componentError}</div>
          );
        } else if (this.state.success) {
          return <div className="alert alert-success">{this.state.success}</div>;
        }
      }

      validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if (this.state.airlineValue === undefined) {
            _errs_["airlineValue"] = "Please select an airline";
            formValid = false;
        }
        if (this.state.flightValue ===  null) {
            _errs_["flightValue"] = "Please select a flight Number";
            formValid = false;
        }
        if (this.state.depValue === null) {
            _errs_["depValue"] = "Please select departure";
            formValid = false;
        }
        if (this.state.flightDate === "") {
            _errs_["flightDate"] = "Please select a date";
            formValid = false;
        }
        if (this.state.desValue === null) {
            _errs_["desValue"] = "Please select destination";
            formValid = false;
        }
        this.setState({ componentErrorMessages: _errs_ });
        return formValid;
    };

    render() {
        let modalResponse = this.renderPageResponse();
        

        const { contentError, currentPage, pageSize, airlineSelectNotification,
            airlines, records, totalCount, selectedFile, commentValue, valueDispute, ticketValue,
            searchFlightNumbers, desAirports, depAirports, tickets, airlineValue, flightValue,
            depValue, desValue, statusValue, componentErrorMessages,
        } = this.state;
        const { requesting, pageRequesting, } = this.props;
        let recordLength = records.length;
        return (
            <div className="view">
                <ViewHeader />
                <ViewContent>
                    <Card className="mb-4">
                        {/*Progress bar for Pending API Request*/}
                        {((pageRequesting || requesting) && !pageRequesting) && <Progress striped animated color="success" value={100} className="mb-2" />}
                        {/*Display loader when component content is dependent on Data from API*/}
                        {(!contentError && pageRequesting) &&
                            <PageLoading />
                        }

                        {/*Display error when component fail to get Data from API*/}
                        {contentError &&
                            <PageError error={this.state.contentError} />
                        }

                        {/* {!pageRequesting && error && (
                            <ComponentPageError error={error} />
                        )} */}
                        {/*Display component content when Data is gotten from API*/}
                        {(!contentError && !pageRequesting) &&
                            <CardBody>
                                <h6 className="mb-0 text-uppercase pull-left">Airline Panel</h6>
                                <div className="clearfix">&nbsp;</div>
                                <SearchPanel
                                    airlines={airlines}
                                    // airlineValue={this.props.user.userRole === appConstants.ROLES.AIRLINE_ADMIN || this.props.user.userRole === appConstants.ROLES.AIRLINE_STAFF ? airlineValue : airlineValue.Id}
                                    user={this.props.user}
                                    airlineValue={airlineValue}
                                    componentErrorMessages={componentErrorMessages}
                                    searchFlightNumbers={searchFlightNumbers}
                                    flightValue={flightValue}
                                    depAirports={depAirports}
                                    depValue={depValue}
                                    desAirports={desAirports}
                                    desValue={desValue}
                                    tickets={tickets}
                                    ticketValue={ticketValue}
                                    status={Status}
                                    statusValue={statusValue}
                                    handleSelectChange={this.handleSelectChange}
                                    handleTicketChange={this.handleTicketChange}
                                    handleAirline={this.handleAirline}
                                    onSearch={this.searchDisputeEntry}
                                    changeDatePicker={this.changeDatePicker}
                                    // flightDateChange={flightDate => this.setState({ flightDate })}
                                    airlineSelectNotification={airlineSelectNotification}
                                />
                                <hr />


                                <CardBody>
                                    {(!pageRequesting && records) &&
                                        <div>
                                            {recordLength > 0 && (
                                                <div style={{ float: "left" }}>
                                                    <h6 className="mb-0 text-uppercase">
                                                        Dispute Records
                                                  <FormText color="muted">
                                                            <ReportIcon size="22" color="#43a8df" />
                                                         &nbsp;
                                                           {appHelpers.numberWithCommasOnly(
                                                                totalCount
                                                            )}{" "}
                                                            records matched
                                                        </FormText>
                                                    </h6>
                                                </div>
                                            )}
                                                 <br />
                                                 <br />   
                                         <PaginatedResult
                                                records={records}
                                                currentPage={currentPage}
                                                navigate={this.searchDisputeEntry}
                                                pageSize={pageSize}
                                                totalCount={totalCount}
                                                initiateToggle={this.initiateToggle}
                                                approveToggle={this.approveToggle}
                                                rejectToggle={this.rejectToggle}
                                                saveToggle={this.saveToggle}
                                                user={this.props.user}
                                                interpretAirport={this.interpretAirport}
                                                interpretDesAirport={this.interpretDesAirport}
                                            />
                                        </div>
                                    }
                                    {(!pageRequesting && !records) &&
                                        <PageEmptyContent message='No record match your search!' />
                                    }

                                    <DisputeModal
                                        modalTopic={"Reject"}
                                        modalDetails={"Are you sure you want to Reject this dispute log?"}
                                        toggle={this.rejectToggle}
                                        isOpen={this.state.isOpenReject}
                                        yesAction={this.reject}
                                        yesText={"Yes"}
                                        noText={"No"}
                                        modalResponse={modalResponse}
                                        requesting={requesting} 
                                    />

                                    <DisputeModal
                                        modalTopic={"Initiate"}
                                        modalDetails={"Are you sure you want to initiate this dispute log?"}
                                        toggle={this.initiateToggle}
                                        isOpen={this.state.isOpenInitiate}
                                        yesAction={this.initiate}
                                        yesText={"Yes"}
                                        noText={"No"}
                                        modalResponse={modalResponse}
                                        requesting={requesting} 
                                    />

                                    <DisputeModal
                                        modalTopic={"Approve"}
                                        modalDetails={"Are you sure you want to approve this dispute log?"}
                                        toggle={this.approveToggle}
                                        isOpen={this.state.isOpenApprove}
                                        yesAction={this.approve}
                                        yesText={"Yes"}
                                        noText={"No"}
                                        modalResponse={modalResponse}
                                        requesting={requesting} 
                                    />

                                    <DisputeModal
                                        modalTopic={"Dispute log"}
                                        toggle={this.saveToggle}
                                        isOpen={this.state.isOpenSave}
                                        yesAction={this.save}
                                        yesText={"Save"}
                                        noText={"No"}
                                        file={"File Path"}
                                        // handleChange={this.handleChange}
                                        handleFileChange={this.handleFileChange}
                                        commentValue={commentValue}
                                        valueDispute={valueDispute}
                                        selectedFile={selectedFile}
                                        handleInputChange={this.handleInputChange}
                                        showForm
                                        modalResponse={modalResponse}
                                        requesting={requesting} 
                                        />


                                </CardBody>
                            </CardBody>
                        }
                        <NotificationSystem ref="notificationSystem" />
                    </Card>
                </ViewContent>
            </div>
        )
    }
}

function mapStateToProps(state, ownProps) {
    const { loggingIn, user } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { alert, manifestReports, modal, entities, airlines, airlinesCarriers, depAirports, desAirports } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        alert,
        modal,
        manifestReports,
        entities,
        airlines,
        airlinesCarriers,
        user,
        desAirports,
        depAirports
    };
}

export default connect(mapStateToProps)(DisputeEntry);


// WEBPACK FOOTER //
// ./src/views/dispute-log/index.js